import { render, staticRenderFns } from "./VehicleCapacityBars.vue?vue&type=template&id=754c7e8c&scoped=true"
import script from "./VehicleCapacityBars.vue?vue&type=script&lang=js"
export * from "./VehicleCapacityBars.vue?vue&type=script&lang=js"
import style0 from "./VehicleCapacityBars.vue?vue&type=style&index=0&id=754c7e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754c7e8c",
  null
  
)

export default component.exports